var render = function render(){var _vm=this,_c=_vm._self._c;return _c('th',_vm._g(_vm._b({staticClass:"text-nowrap",attrs:{"aria-sort":_vm.ariaSort},on:{"click":_vm.setSort}},'th',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }